import { ACTION_IDS } from '../../../../../components/PopoverMenu'
import { GWS } from '../../../engage/utils'

const OFFICE365_POPOVER_MENU_CONFIG = [
  {
    title: 'ENGAGE.SECURITY_ACTIONS',
    items: [
      { id: ACTION_IDS.RevokeSessions, label: 'ENGAGE.SIGN_OUT_ALL_APPS_NO_HYPHEN' },
      { id: ACTION_IDS.ReRegisterMfa },
      { id: ACTION_IDS.TemporaryAccessPass },
    ],
  },
  {
    title: 'ENGAGE.MANAGEMENT_ACTIONS',
    items: [
      {
        id: 'groups',
        label: 'ENGAGE.GROUPS',
        subMenu: {
          title: 'ENGAGE.EDIT_GROUPS',
          items: [
            { id: ACTION_IDS.ManageGroups, label: 'ENGAGE.M365' },
            { id: ACTION_IDS.ManageSecurityGroups, label: 'ENGAGE.SECURITY' },
            { id: ACTION_IDS.ManageDistributionMailboxes, label: 'ENGAGE.DISTRIBUTION_MAIL_ENABLED_SECURITY' },
          ],
        },
      },
      { id: ACTION_IDS.ManageLicenses },
      { id: ACTION_IDS.OutOfOffice },
      { id: ACTION_IDS.GlobalAddressList },
      { id: ACTION_IDS.ManageEmailForwarding },
      { id: ACTION_IDS.ManageMailboxPermissions },
      { id: ACTION_IDS.ManageSharedMailboxes, label: 'ENGAGE.SHARED_MAILBOX_ACCESS' },
      { id: ACTION_IDS.OffboardUser },
    ],
  },
]

const GWS_POPOVER_MENU_CONFIG = [
  {
    title: 'ENGAGE.MANAGEMENT_ACTIONS',
    items: [{ id: ACTION_IDS.ManageGroups }, { id: ACTION_IDS.ManageLicenses }, { id: ACTION_IDS.OffboardUser }],
  },
]

export const getPopoverMenuConfig = (integrationType) =>
  integrationType === GWS ? GWS_POPOVER_MENU_CONFIG : OFFICE365_POPOVER_MENU_CONFIG
